<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">添付ファイル情報</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet class="pa-2" elevation="0">
				<v-row justify="end" no-gutters v-if="authority_flag">
					<TemplateDeleteDialog
						ref="deleteDialog"
						:openBtnColor="'red'"
						:openBtnDesign="['dark']"
						:deleteMethod="deleteFile"
					>
						<template v-slot:btn-text>削除</template>
						<template v-slot:text>
							本当に削除してよろしいですか？<br />
							履歴は残りますがファイルは完全に削除されます
						</template>
					</TemplateDeleteDialog>
					<v-menu v-model="menu" :close-on-content-click="false">
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="ml-2" color="secondary" dark v-bind="attrs" v-on="on">
								<v-icon class="mr-1">mdi-pencil</v-icon>
								編集
							</v-btn>
						</template>

						<v-card width="600px" class="top-border-menu">
							<v-form ref="form" v-model="valid" class="pa-2">
								<v-textarea
									class="mt-4 no-line"
									label="現在のファイル名"
									v-model="attached_file.name"
									rows="1"
									auto-grow
									readonly
									outlined
									dense
								/>
								<v-text-field
									class="mt-4"
									label="新しいファイル名"
									v-model="fileName"
									:rules="[rules.required]"
									hint="拡張子は自動で付与されます。"
									outlined
									dense
								>
									<template v-slot:append-outer>
										{{ "." + extension }}
									</template>
								</v-text-field>
							</v-form>
							<v-card-actions class="ma-0">
								<v-row no-gutters justify="space-around">
									<v-btn color="secondary" :dark="valid" @click="updateFile()" :disabled="!valid">
										<v-icon class="mr-1">mdi-content-save</v-icon>
										保存
									</v-btn>
									<v-btn text @click="menu = false"> キャンセル </v-btn>
								</v-row>
							</v-card-actions>
						</v-card>
					</v-menu>
				</v-row>
				<table width="100%" class="mt-4 show-dialog-table">
					<tbody>
						<ShowDetailRecord :columnName="'ファイル名'">
							<template v-slot:value>
								<v-row no-gutters class="flex-nowrap">
									<a :href="attached_file.url" class="d-block" target="_blank">
										{{ attached_file.name }}
									</a>
								</v-row>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord
							:columnName="'登録日'"
							:value="common.formatDate(attached_file.created_at)"
						/>
						<ShowDetailRecord :columnName="'登録者'" :value="attached_file.user.full_name" />
					</tbody>
				</table>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import TemplateDeleteDialog from "../../shared/TemplateDeleteDialog.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		attached_file: {
			type: null,
			required: false,
			default: () => {
				return {
					id: null,
					name: null,
					created_at: null,
					user: {
						full_name: null,
					},
				}
			},
		},
		authority_flag: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	components: {
		ShowDetailRecord,
		TemplateDeleteDialog,
	},
	data() {
		return {
			menu: false,
			valid: false,
			fileName: "",
			extension: "",
			common,
			rules,
		}
	},
	methods: {
		updateFile() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/attached_files/${this.attached_file.id}`
			const params = { name: `${this.fileName}.${this.extension}` }
			axios
				.put(url, params, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "ファイル名を変更しました。",
					})
					this.menu = false
					this.$emit("update-attached-file", res.data)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		deleteFile() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/attached_files/${this.attached_file.id}`
			axios
				.delete(url, { headers })
				.then((res) => {
					this.$emit("delete-attached-file", res.data)
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "ファイルを削除しました。",
					})
					this.$refs.deleteDialog.closeDialog()
					this.showDialog = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
	watch: {
		attached_file(newVal) {
			let file = newVal.name.split(".")
			this.extension = file[file.length - 1]
			file = file.slice(0, file.length - 1)
			this.fileName = file.join(".")
		},
		deep: true,
	},
}
</script>